//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CardSlider, Typography } from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'

import BuyingGuideCard from '@buying-guide/components/Card'

import translations from './Guides.translations'

export default {
  components: {
    Typography,
    CardSlider,
    BuyingGuideCard,
  },
  props: {
    guides: { type: Array, required: true },
  },
  computed: {
    hasGuides() {
      return !isEmpty(this.guides)
    },
    translations: () => translations,
  },
}
